import { render, staticRenderFns } from "./array_tag_editor.vue?vue&type=template&id=58a91ec2"
import script from "./array_tag_editor.vue?vue&type=script&lang=js"
export * from "./array_tag_editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports